export const initAppleId = clientId => {
  window.AppleID.auth.init({
    clientId,
    scope: 'name email',
    redirectURI: window.location.origin,
    state: 'init',
    usePopup: true
  });
};